import { environment } from "./environment.base";


export function useVirtualEnv() {

  return {
    env: {...environment}
  };
}


export function insertAfter(newElement, targetElement) {
  const parent = targetElement.parentNode;
  if (parent.lastChild === targetElement) {
    // 如果最后的节点是目标元素，则直接添加。因为默认是最后
    parent.appendChild(newElement);
  } else {
    parent.insertBefore(newElement, targetElement.nextSibling);
    // 如果不是，则插入在目标元素的下一个兄弟节点 的前面。也就是目标元素的后面
  }
}

export function setEnvParams () {
  const {env} = useVirtualEnv();
  const metas = document.querySelectorAll('meta');
  let exit = false;

  metas.forEach(value => {
    const paramKey = value.getAttribute('name');

    if (paramKey) {
      if (paramKey === 'branch' && env) {
        exit = true;
        value.setAttribute('content', env.branch);
      }
      if (paramKey === 'tag' && env) {
        exit = true;
        value.setAttribute('content', env.tag);
      }
    }
  });

  if (!exit) {
    const last = metas.item(metas.length - 1);

    if (last && env.branch) {
      const metaElement = document.createElement('meta');
      metaElement.setAttribute('name', 'branch');
      metaElement.setAttribute('content', env.branch);
      // last.insertBefore(metaElement);
      insertAfter(metaElement, last);

      if (env.tag) {
        const metaTagElement = document.createElement('meta');
        metaTagElement.setAttribute('name', 'tag');
        metaTagElement.setAttribute('content', env.tag);
        // last.insertBefore(metaElement);
        insertAfter(metaTagElement, metaElement);
      }
    }
  }
}

export function sentryRelease() {
  const {env: {sentry = {}}} = useVirtualEnv();

  const {env, testName, project, branch} = sentry;

  const b = branch
    .replace(/\//g, '.')
    .replace(/\\/g, '.')

  switch (env) {
    case 'test': {
      return `[${env}][${testName}][${project}]`
    }
    case 'demo':
    case 'preProd': {
      return `[${env}][${project}]${b}`
    }
    case 'prod': {
      return `[${env}][${project}]`
    }
  }
}

